import { JobDetail, JobsReponse } from '@/types/Job'

export const getFullAddress = (job: JobDetail) => {
  const property = job?.home?.property
  return `${property?.address1} ${property?.address2 ? property?.address2 : ''}`
}

export const isJobClaimed = (job: JobDetail | JobsReponse) => {
  return !!job?.claimedAt
}
